module.exports = __webpack_public_path__ + "img/gift3-03-c1.3945211a.png";